import { render, staticRenderFns } from "./mainBarRight.vue?vue&type=template&id=1ba53e70&scoped=true&"
import script from "./mainBarRight.vue?vue&type=script&lang=js&"
export * from "./mainBarRight.vue?vue&type=script&lang=js&"
import style0 from "./mainBarRight.vue?vue&type=style&index=0&id=1ba53e70&prod&lang=scss&scoped=true&"
import style1 from "./mainBarRight.vue?vue&type=style&index=1&id=1ba53e70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba53e70",
  null
  
)

export default component.exports